import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Main product image (transparent background)
  const productImageUrl = 'https://cdn.magicpatterns.com/uploads/46yUt53eneNYCbcKGL9k5d/f7c01aaf-0875-4bec-9e1f-fc086468bb10-removebg-preview.png';
  return <section className="relative bg-white h-screen flex flex-col px-4 py-0" data-id="element-57">
      {/* Micro etiqueta - Al raz de arriba */}
      <div className="pt-3 text-center shrink-0" data-id="element-58">
        <span className="inline-block rounded-full bg-blue-100 px-3 py-1 text-[10px] md:text-xs font-bold uppercase tracking-wider text-blue-800" data-id="element-59">
          PARA DOCENTES QUE NECESITAN SOLUCIONES REALES EN EL AULA
        </span>
      </div>

      {/* Content container - Distribuido en el espacio restante */}
      <div className="flex-1 flex flex-col justify-between py-2" data-id="element-60">
        {/* Headlines */}
        <div className="text-center shrink-0" data-id="element-61">
          {/* Headline */}
          <h1 className="mx-auto max-w-4xl text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-gray-900" data-id="element-62">
            RECUPERÁ EL CONTROL DEL AULA
          </h1>

          {/* Subheadline fuerte - Amarillo */}
          <p className="mt-1 md:mt-2" data-id="element-63">
            <span className="bg-yellow-300 px-2 py-1 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black text-gray-900 inline-block" data-id="element-64">
              SIN GRITAR, SIN CASTIGAR
            </span>
          </p>

          {/* Línea clave explicativa */}
          <p className="mt-2 md:mt-4 mx-auto max-w-2xl text-sm md:text-lg text-gray-600 leading-snug" data-id="element-65">
            Un sistema práctico con frases, rutinas y técnicas listas para usar
            cuando la clase se desordena.
          </p>

          {/* Refuerzo de uso inmediato */}
          <p className="mt-1 md:mt-2 text-xs md:text-base font-semibold text-gray-800" data-id="element-66">
            Abrís el material → elegís la situación → aplicás en 3 a 10 minutos.
          </p>
        </div>

        {/* Product Image - Centro, lo más grande posible */}
        <div className="flex-1 flex items-center justify-center py-2 cursor-pointer min-h-0" onClick={scrollToCompra} data-id="element-67">
          <img src={productImageUrl} alt="Mega Kit Supervivencia Docente - 6 Tomos Prácticos + 3 Bonos Exclusivos" className="max-h-full max-w-full object-contain" data-id="element-68" />
        </div>

        {/* Value Props + CTA - Al raz de abajo */}
        <div className="shrink-0 text-center" data-id="element-69">
          {/* Value Props Bar */}
          <div className="flex flex-wrap justify-center gap-2 mb-3 text-[10px] md:text-sm font-semibold text-gray-700" data-id="element-70">
            <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 md:px-4 md:py-2 rounded-full" data-id="element-71">
              <span data-id="element-72">📥 Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 md:px-4 md:py-2 rounded-full" data-id="element-73">
              <span data-id="element-74">🔒 Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 md:px-4 md:py-2 rounded-full" data-id="element-75">
              <span data-id="element-76">🛡️ Garantía 7 días</span>
            </div>
          </div>

          {/* Main CTA - Al raz del borde inferior */}
          <div className="pb-4" data-id="element-77">
            <CTAButton className="text-sm md:text-xl px-6 md:px-10 py-3 md:py-5 w-full max-w-md mx-auto" data-id="element-78">
              SÍ, QUIERO EL MEGA KIT AHORA
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}